import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/splus-dragon-card/Index.vue')

const indexRoute: RouteConfig = {
  path: '/activity/splus-dragon-card',
  name: 'activity_splus_dragon_card',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2024龙年S+会员年卡',
  },
}

export default [indexRoute]
